// libs
import { create } from 'zustand';
// constants
import { INITIAL_STATE } from './constants';
const useNotificationsStore = create((set, get) => (Object.assign(Object.assign({}, structuredClone(INITIAL_STATE)), { addNotification: (notification) => set({
        notifications: [...get().notifications, notification],
    }), removeNotification: (notificationId) => {
        const currentNotifications = get().notifications;
        const index = currentNotifications.findIndex((n) => n.id === notificationId);
        if (index > -1) {
            currentNotifications.splice(index, 1);
            set({ notifications: currentNotifications });
        }
    }, clear: () => set({ notifications: [] }) })));
export default useNotificationsStore;
